import VideoModal from '../videoModal'
import { useModal } from 'hooks'
import { t } from 'i18next'
import styled from 'styled-components'

const StyledTitle = styled.div`
  bottom: 0;
  font-size: 1.4rem;
  font-weight: 600;
  left: 0;
  position: absolute;
  right: 0;
  text-align: center;
  width: 100%;
  z-index: 1;
  display: flex;
  padding: 0 8px;
  justify-content: center;
  p {
    color: white;
  }
`
const StyledContainerVideo = styled.div`
  width: 100%;
  height: 100%;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  border-radius: 12px;
  overflow: hidden;
`
const StyledContainerThumbnail = styled.div`
  position: relative;
  cursor: pointer;
  &:hover {
    img {
      filter: invert(0%);
      -webkit-filter: invert(0%);
    }
    .thumbnail-coating {
      background-image: linear-gradient(
        180deg,
        rgba(30, 30, 28, 0),
        rgba(30, 30, 28, 0.5)
      );
    }
    .thumbnail-title {
      font-weight: 600;
    }
  }
  img {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 60px;
    height: 60px;
    filter: invert(250%);
    -webkit-filter: invert(25%);
  }
`

const StyledCoating = styled.div`
  background-image: linear-gradient(
    180deg,
    rgba(30, 30, 28, 0),
    rgba(30, 30, 28, 0.9)
  );
  bottom: 0;
  content: '';
  display: block;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  transition: all 0.3s linear;
`
const StyledThumbnail = styled.div`
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: 100% auto;
  padding-top: 56.25%;
  width: 100%;
`

interface IProps {
  header?: string
  title?: string
  videoId?: string
  thumbnail?: string
}

const VideoThumbnail = (props: IProps) => {
  const { videoId, header, title, thumbnail } = props
  const modal = useModal()

  const handleOpenVideo = () => {
    modal.open(<VideoModal videoId={videoId} header={header} title={title} />, {
      footer: null,
      width: '80%',
      maxWidth: 816,
      minHeight: 580,
      className: 'video-thumbnail'
    })
  }

  return (
    <StyledContainerVideo>
      <StyledContainerThumbnail onClick={handleOpenVideo}>
        <StyledCoating className="thumbnail-coating" />
        <StyledThumbnail
          style={{
            backgroundImage: `url(${
              thumbnail
                ? thumbnail
                : `https://img.youtube.com/vi/${videoId}/mqdefault.jpg)`
            }`,
            backgroundSize: '300px 200px'
          }}
        />
        <img src="/images/ic-play.svg" alt=""></img>
        <StyledTitle className="thumbnail-title">
          <p>{t(title || '')}</p>
        </StyledTitle>
      </StyledContainerThumbnail>
    </StyledContainerVideo>
  )
}

export default VideoThumbnail
